import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { formatJsonDate } from '../util';
import { DDSRecord } from './traces-dds-detail.component';

@Component({
  selector: 'app-traces-product-dds-dialog',
  templateUrl: './traces-product-dds-dialog.component.html',
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatIconModule,
    MatButtonModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    TranslateModule,
  ],
  styleUrl: './traces-product-dds-dialog.component.scss',
})
export class TracesProductDdsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<TracesProductDdsDialogComponent>);
  private readonly data = inject<{ ddsData?: DDSRecord }>(MAT_DIALOG_DATA);
  readonly isEditMode = !!this.data.ddsData;

  ddsForm = new FormBuilder().nonNullable.group({
    ddr: [this.data.ddsData?.ddr || '', Validators.required],
    ddv: [this.data.ddsData?.ddv || '', Validators.required],
    dateReceived: [
      this.data.ddsData?.dateReceived ? new Date(this.data.ddsData.dateReceived) : new Date(),
      Validators.required,
    ],
    comment: [this.data.ddsData?.comment || ''],
    tags: [this.data.ddsData?.tags || ([] as string[])],
  });

  tags: string[] = this.data.ddsData?.tags || [];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  addTag(event: MatChipInputEvent | HTMLInputElement, input: HTMLInputElement): void {
    const value = (event.value || '').trim();
    if (value) {
      this.tags.push(value);
      this.updateFormTags();
      this.ddsForm.get('tags')?.markAsDirty();
    }
    event.value = '';
    input.value = '';
  }

  removeTag(tag: string): void {
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);
      this.updateFormTags();
      this.ddsForm.get('tags')?.markAsDirty();
    }
  }

  addPendingTag(event: FocusEvent, input: HTMLInputElement): void {
    if (event.target) {
      this.addTag(event.target as HTMLInputElement, input);
      this.ddsForm.get('tags')?.markAsDirty();
    }
  }

  private updateFormTags(): void {
    this.ddsForm.patchValue({ tags: [...this.tags] });
  }

  add(): void {
    if (this.ddsForm.valid) {
      const data = this.ddsForm.value as any;
      this.dialogRef.close({ ...data, dateReceived: formatJsonDate(data.dateReceived) });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
